import {useEffect, useState} from "react";
import {useAuthStore} from "../store/authStore";
import {addBreadcrumb} from "../utils/auth";

declare global {
    interface Window {
        _hsq?: any[];
    }
}

export const useHubSpot = () => {
    const payload = useAuthStore((state) => state.payload);
    const [scriptLoaded, setScriptLoaded] = useState(false);

    useEffect(() => {
        const existingScript = document.getElementById("hs-script-loader");
        if (existingScript) {
            setScriptLoaded(true);
            console.info("[useHubSpot] HubSpot script already loaded");
            return;
        }
        console.info("[useHubSpot] Loading HubSpot script");

        const script = document.createElement('script');
        script.src = 'https://js-eu1.hs-scripts.com/144765123.js';
        script.async = true;
        script.defer = true;
        script.id = 'hs-script-loader';

        script.onload = () => {
            console.info("[useHubSpot] HubSpot script loaded");
            setScriptLoaded(true);
        };

        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    useEffect(() => {
        if (!scriptLoaded || !payload?.email || !window._hsq) return;
        window._hsq.push([
            "trackEvent",
            {
                id: "user_identification",
                email: payload.email
            }
        ]);
        window._hsq.push(["identify", { email: payload.email }]);
        console.info("[useHubSpot] Identified user in HubSpot as", payload.email);
        addBreadcrumb("HubSpot identified", { email: payload.email });
    }, [scriptLoaded, payload?.email]);
};
